<template>
  <dialog-wrapper :title="this.$t('user_login.wayfinder_code')">
    <template #content>
      <div>
        <Skeleton
          v-if="loadingCamera"
          class="w-full"
          style="height: 427px;" />
        <qrcode-stream
          v-show="!loadingCamera"
          :paused="paused"
          :track="paintOutlines"
          @detect="onDetect"
          @error="onError"
          @camera-on="resetValidationState">
          <span
            v-if="pending || paused"
            class="pending">
            <i class="fa-duotone fa-circle-notch fa-spin spinner"></i>
          </span>
        </qrcode-stream>
        <div
          v-if="error"
          class="text-danger mt-16 rounded-4 bg-[#FFCCCC] p-16 text-center text-14">
          {{ error }}
        </div>
      </div>
    </template>
  </dialog-wrapper>
</template>

<script>
import {
  QrcodeStream
} from "vue-qrcode-reader";

import Skeleton from "primevue/skeleton";

import Helpers from "@/mixins/Helpers";
import DialogWrapper from "@/components/wrappers/DialogWrapper";

export default {
  components: {
    QrcodeStream,
    Skeleton,
    DialogWrapper
  },
  mixins: [
    Helpers
  ],
  inject: [
    "dialogRef"
  ],
  data() {
    return {
      loadingCamera: true,
      isValid: undefined,
      paused: false,
      result: null,
      error: null
    };
  },
  computed: {
    pending() {
      return this.isValid === undefined && this.paused;
    }
  },
  methods: {
    onError: console.error,
    resetValidationState() {
      this.loadingCamera = false;
      this.isValid = undefined;
    },
    async onDetect([
      firstDetectedCode
    ]) {
      this.error = null;
      this.result = firstDetectedCode.rawValue;

      await this.timeout(1000);
      this.paused = true;
      await this.timeout(1000);
      const regex = /\/login\?direct=([^&]+)&key=([^&]+)/;
      const match = regex.exec(this.result);
      this.isValid = match !== null;

      if (this.isValid) {
        this.dialogRef.close();
        this.paused = false;

        const [, direct, key] = match;

        try {
          await this.storeDispatch("userLogin", {
            direct,
            key
          });

          this.showHomeScreen();
        }
        catch (error) {
          this.showToastNew("error", this.$t(`error_messages.${error?.response?.data?.error}`));
        }
      }
      else {
        this.paused = false;
        this.error = this.$t("scan_qrcode.error");
      }
    },
    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },
    paintOutlines(codes, ctx) {
      for (const code of codes) {
        const {
          boundingBox: { x, y, width, height }
        } = code;

        // Gradient Border
        const gradient = ctx.createLinearGradient(x, y, x + width, y + height);
        gradient.addColorStop(0, "#015440");
        gradient.addColorStop(1, "#029383");

        // Rounded
        const radius = 4;
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();

        // Shadow
        ctx.shadowColor = "rgba(0, 0, 0, 0.5)";
        ctx.shadowBlur = 10;
        ctx.shadowOffsetX = 3;
        ctx.shadowOffsetY = 3;

        ctx.lineWidth = 3;
        ctx.strokeStyle = gradient;
        ctx.stroke();

        ctx.shadowColor = "transparent";
      }
    }
  }
};
</script>

<style scoped>
.pending {
  @apply flex w-full h-full p-10 text-center font-bold text-[1.4rem] text-black items-center justify-center;

  background-color: rgba(255, 255, 255, 0.8);
}
.spinner {
  @apply text-[60px] text-grey-3;
}

:deep(video) {
  @apply rounded-8 h-[500px];
}

</style>